module.exports = __webpack_public_path__ + "static/media/onkyo-es-cti300.7fc1d925.jpg";